<template>
  <BaseButton
    class="button--common"
    :class="displayClass"
    :disabled="disabled"
    :flat="flat"
    :hg-label="label"
    :type="type"
    @click="handleClick" />
</template>

<script>
import { Components } from '@spectorasoftware/homegauge-vue';

const { BaseButton } = Components;

const BUTTON_TYPES = ['button', 'submit'];
const BUTTON_VARIANTS = ['alert', 'secondary', 'success'];

const booleanPropType = {
  type: Boolean,
  default: false,
};

export { BUTTON_TYPES, BUTTON_VARIANTS };
export default {
  components: {
    BaseButton,
  },
  props: {
    border: booleanPropType,
    block: booleanPropType,
    disabled: booleanPropType,
    flat: booleanPropType,
    jumbo: booleanPropType,
    type: {
      type: String,
      default: 'button',
      validator: val => BUTTON_TYPES.includes(val),
    },
    variant: {
      type: String,
      validator: val => (val ? BUTTON_VARIANTS.includes(val) : true),
    },
  },
  computed: {
    displayClass() {
      return {
        'button--common-alert': this.variant === 'alert',
        'button--common-block': this.block,
        'button--common-border': this.border,
        'button--common-flat': this.flat,
        'button--common-jumbo': this.jumbo,
        'button--common-secondary': this.variant === 'secondary',
        'button--common-success': this.variant === 'success',
      };
    },
    label() {
      return this.$slots.default && this.$slots.default[0]
        ? this.$slots.default[0].text
        : '';
    },
  },
  methods: {
    handleClick() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/buttons';

.button--common {
  background: $button-background;
  border-radius: $button-border-radius;
  color: $button-color-dark;
  display: inline-block;
  letter-spacing: 0.05rem;
  line-height: 1;
  padding: 0.975rem 1.4rem;
  width: auto;

  &-block {
    display: block;
    width: 100%;
  }

  &-jumbo {
    font-size: 1.15rem;
    padding: 1.15rem 1.75rem;
  }

  &-alert {
    background: $button-background-alert;
    color: $button-color;
  }

  &-secondary {
    background: $button-background-secondary;
    color: $button-color;
  }

  &-success {
    background: $button-background-success;
    color: $button-color;
  }

  &-border {
    background-color: $theme-color-white;
    border: 2px solid #dddfe7;
    color: $theme-color-secondary;
  }

  &-flat {
    background: none;
    border: none;
  }
}
</style>
